export default __webpack_public_path__ + "static/media/jason-warner.fa7f7755.jpg";